import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { competitionEndpoints } from '../../../../constants';
import { CreateCompetition } from '../../../general/schemas/competition.schema';
import { ICompetition } from '../../entities/competitions';

class CompetitionsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (competition: CreateCompetition): Promise<ICompetition> => {
    return this.#requestInstance.post(competitionEndpoints.competition, competition);
  };

  getCompetitions = async (): Promise<ICompetition[]> => {
    return this.#requestInstance.get(competitionEndpoints.competition);
  };

  deleteCompetition = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(competitionEndpoints.getCompetitionById(id));
  };

  getCompetition = async (id: number): Promise<ICompetition> => {
    return this.#requestInstance.get(competitionEndpoints.getCompetitionById(id));
  };

  updateCompetition = async (input: ICompetition): Promise<ICompetition> => {
    return this.#requestInstance.patch(competitionEndpoints.getCompetitionById(input?.id), input);
  };

  updateCompetitionStatus = async (input: ICompetition): Promise<ICompetition> => {
    return this.#requestInstance.patch(
      competitionEndpoints.updateCompetitionStepById(input?.id),
      input
    );
  };
}

export const competitionsApi = new CompetitionsApi(axios);
